import dataFetcher from "../dataFetcher";

export const getForkliftDriversService = async () => {
  try {
    const res = await dataFetcher.post("/montacargas/pilotosmontacarga");
    return {
      data: res.data,
      success: true,
    };
  } catch (error) {
    return {
      error: error.response.data,
      success: false,
    };
  }
};

export const assignForkliftService = async (data) => {
  try {
    const res = await dataFetcher.post(
      "/solicitudsalida/asignarmontacarga",
      data
    );
    return {
      data: res.data,
      success: true,
    };
  } catch (error) {
    return {
      error: error.response.data,
      success: false,
    };
  }
};
